'use strict';

import angular from 'angular';

/**
 * GlobalSearchService – recherche transversale sur toutes les sections du projet.
 */
angular.module('observatoireApp')
  .service('GlobalSearchService', ['$http', '$q', 'VideothequeService', 'ContratsService', 'AutorisationsService', 'PublicationsService',
    function($http, $q, VideothequeService, ContratsService, AutorisationsService, PublicationsService) {

      /* ─── Index statique des pages ─────────────────────────── */
      var PAGES = [
        { titre: 'Budget Général',           desc: 'Lois de finances, recettes et dépenses de l\'État',      state: 'main.open-budget-general',        icon: 'fa-bar-chart',      categorie: 'Budget' },
        { titre: 'Budget Citoyen',           desc: 'Version simplifiée du budget pour les citoyens',          state: 'main.open-budget-citoyen',        icon: 'fa-users',          categorie: 'Budget' },
        { titre: 'Budget Local',             desc: 'Finances des collectivités territoriales',                 state: 'main.open-budget-local',          icon: 'fa-map',            categorie: 'Budget' },
        { titre: 'Budget d\'Investissement', desc: 'Programme d\'investissements publics',                    state: 'main.budget-investissement',      icon: 'fa-line-chart',     categorie: 'Budget' },
        { titre: 'Contrats Pétroliers',      desc: 'Contrats et conventions avec les compagnies pétrolières', state: 'main.contrats-petroliers',        icon: 'fa-industry',       categorie: 'Secteur Extractif' },
        { titre: 'Autorisations de Recherche', desc: 'Permis de recherche d\'hydrocarbures',                  state: 'main.autorisations-recherche',    icon: 'fa-search',         categorie: 'Secteur Extractif' },
        { titre: 'Autorisations d\'Exploitation', desc: 'Autorisations d\'exploitation pétrolière',           state: 'main.autorisations-exploitation', icon: 'fa-certificate',    categorie: 'Secteur Extractif' },
        { titre: 'Conventions Minières',     desc: 'Conventions accordées pour l\'exploitation minière',      state: 'main.conventions-minieres',       icon: 'fa-handshake-o',    categorie: 'Secteur Minier' },
        { titre: 'Titres Miniers',           desc: 'Titres attribués pour l\'exploration minière',            state: 'main.titres-miniers',             icon: 'fa-diamond',        categorie: 'Secteur Minier' },
        { titre: 'Blocs Pétroliers',         desc: 'Carte et liste des blocs pétroliers du Tchad',           state: 'main.blocs-petroliers',           icon: 'fa-globe',          categorie: 'Secteur Extractif' },
        { titre: 'Carte Pétrolière',         desc: 'Carte interactive des zones pétrolières',                 state: 'main.carte-petroliere',           icon: 'fa-map-marker',     categorie: 'Secteur Extractif' },
        { titre: 'Publications',             desc: 'Rapports, études et documents officiels',                 state: 'main.publications',               icon: 'fa-file-text-o',    categorie: 'Publications' },
        { titre: 'Textes Officiels',         desc: 'Textes législatifs et réglementaires',                    state: 'main.textes-officiels',           icon: 'fa-file-text',      categorie: 'Publications' },
        { titre: 'Vidéothèque',              desc: 'Vidéos explicatives et documentaires',                    state: 'main.videotheque',                icon: 'fa-play-circle',    categorie: 'Médias' },
        { titre: 'Glossaire',               desc: 'Définitions des termes des finances publiques',            state: 'main.glossaire',                  icon: 'fa-book',           categorie: 'Ressources' },
        { titre: 'Applications mobiles',     desc: 'OTFIP, E-Fonctionnaire, CGI sur iOS et Android',         state: 'main.applications',               icon: 'fa-mobile',         categorie: 'Applications' },
      ];

      /* ─── Recherche dans l'index des pages ─────────────────── */
      function searchPages(q) {
        var lower = q.toLowerCase();
        return PAGES.filter(function(p) {
          return p.titre.toLowerCase().indexOf(lower) !== -1 ||
                 p.desc.toLowerCase().indexOf(lower)  !== -1 ||
                 p.categorie.toLowerCase().indexOf(lower) !== -1;
        }).map(function(p) {
          return angular.extend({}, p, { type: 'page' });
        });
      }

      /* ─── Recherche dans les vidéos ────────────────────────── */
      function searchVideos(q) {
        var lower = q.toLowerCase();
        return VideothequeService.getVideos().then(function(videos) {
          return videos.filter(function(v) {
            return (v.titre  || '').toLowerCase().indexOf(lower) !== -1 ||
                   (v.description || '').toLowerCase().indexOf(lower) !== -1 ||
                   (v.categorie   || '').toLowerCase().indexOf(lower) !== -1;
          }).slice(0, 5).map(function(v) {
            return {
              type:      'video',
              categorie: 'Vidéos',
              icon:      'fa-play-circle',
              titre:     v.titre,
              desc:      v.description || v.categorie || '',
              state:     'main.videotheque',
              thumbnail: v.thumbnail,
              raw:       v
            };
          });
        }).catch(function() { return []; });
      }

      /* ─── Recherche dans les contrats ──────────────────────── */
      function searchContrats(q) {
        var lower = q.toLowerCase();
        return ContratsService.getContrats().then(function(contrats) {
          var list = Array.isArray(contrats) ? contrats : (contrats.content || []);
          return list.filter(function(c) {
            return (c.denomination     || '').toLowerCase().indexOf(lower) !== -1 ||
                   (c.typeContrat      || '').toLowerCase().indexOf(lower) !== -1 ||
                   (c.reference        || '').toLowerCase().indexOf(lower) !== -1 ||
                   (c.matiereContractee|| '').toLowerCase().indexOf(lower) !== -1;
          }).slice(0, 5).map(function(c) {
            return {
              type:      'contrat',
              categorie: 'Contrats Pétroliers',
              icon:      'fa-industry',
              titre:     c.denomination || c.titre || '',
              desc:      c.typeContrat  || c.reference || '',
              state:     'main.contrats-petroliers'
            };
          });
        }).catch(function() { return []; });
      }

      /* ─── Recherche dans les autorisations ─────────────────── */
      function searchAutorisations(q) {
        var lower = q.toLowerCase();
        return AutorisationsService.getAutorisations().then(function(data) {
          var list = Array.isArray(data) ? data : (data.content || []);
          return list.filter(function(a) {
            return (a.denomination      || '').toLowerCase().indexOf(lower) !== -1 ||
                   (a.typeAutorisation  || '').toLowerCase().indexOf(lower) !== -1 ||
                   (a.reference         || '').toLowerCase().indexOf(lower) !== -1;
          }).slice(0, 5).map(function(a) {
            return {
              type:      'autorisation',
              categorie: 'Autorisations de Recherche',
              icon:      'fa-certificate',
              titre:     a.denomination     || a.reference || '',
              desc:      a.typeAutorisation || '',
              state:     'main.autorisations-recherche'
            };
          });
        }).catch(function() { return []; });
      }

      /* ─── Recherche dans les publications ──────────────────── */
      function searchPublications(q) {
        return PublicationsService.searchPublications(q).then(function(list) {
          var arr = Array.isArray(list) ? list : (list.content || []);
          return arr.slice(0, 5).map(function(p) {
            return {
              type:      'publication',
              categorie: 'Publications',
              icon:      'fa-file-text-o',
              titre:     p.title || p.titre || '',
              desc:      p.description || p.category || '',
              state:     'main.publications'
            };
          });
        }).catch(function() { return []; });
      }

      /* ─── API publique ─────────────────────────────────────── */

      /**
       * Recherche instantanée (dropdown) — retourne max 3 résultats par catégorie.
       */
      this.quickSearch = function(query) {
        if (!query || query.trim().length < 2) return $q.resolve([]);

        var q = query.trim();
        var pages = searchPages(q).slice(0, 3).map(function(p) {
          p.categorie = 'Pages';
          return p;
        });

        return $q.all([
          searchVideos(q),
          searchContrats(q),
          searchAutorisations(q),
          searchPublications(q)
        ]).then(function(results) {
          var videos        = results[0].slice(0, 3);
          var contrats      = results[1].slice(0, 3);
          var autorisations = results[2].slice(0, 3);
          var publications  = results[3].slice(0, 3);

          return pages.concat(publications, videos, contrats, autorisations);
        });
      };

      /**
       * Recherche complète pour la page de résultats.
       */
      this.fullSearch = function(query) {
        if (!query || query.trim().length < 2) return $q.resolve({ total: 0, groups: [] });

        var q = query.trim();
        var pages = searchPages(q);

        return $q.all([
          searchVideos(q),
          searchContrats(q),
          searchAutorisations(q),
          searchPublications(q)
        ]).then(function(results) {
          var videos        = results[0];
          var contrats      = results[1];
          var autorisations = results[2];
          var publications  = results[3];

          var groups = [];
          if (pages.length)        groups.push({ label: 'Pages & Sections',          icon: 'fa-sitemap',       items: pages });
          if (publications.length) groups.push({ label: 'Publications',              icon: 'fa-file-text-o',   items: publications });
          if (videos.length)       groups.push({ label: 'Vidéos',                   icon: 'fa-play-circle',   items: videos });
          if (contrats.length)     groups.push({ label: 'Contrats Pétroliers',       icon: 'fa-industry',      items: contrats });
          if (autorisations.length)groups.push({ label: 'Autorisations de Recherche',icon: 'fa-certificate',   items: autorisations });

          var total = groups.reduce(function(s, g) { return s + g.items.length; }, 0);
          return { total: total, groups: groups, query: q };
        });
      };
    }
  ]);
